import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class DashboardGuard implements CanActivate {
  private readonly router = inject(Router);

  canActivate(): boolean {
    const currentTenant = localStorage.getItem('current_tenant');
    if (currentTenant) {
      const tenant = JSON.parse(currentTenant);
      const dashboardPath = tenant.type === 'Official' ? '/dashboard' : '/tenant-dashboard';
      this.router.navigate([dashboardPath]);
      return false;
    }
    return true;
  }
}
